module.exports = __webpack_public_path__ + "static/johnson-f228605c8fae19af415603ef03897b53.png";